/**
 * @generated SignedSource<<ade4dac234fccd627374dc7627f8e1f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type jobsQuery$variables = {
  includeJobData?: boolean | null | undefined;
  pageNum?: number | null | undefined;
  pageSize?: number | null | undefined;
  search?: string | null | undefined;
  searchBy?: ReadonlyArray<string | null | undefined> | null | undefined;
  sortBy?: string | null | undefined;
  sortDir?: SortDirection | null | undefined;
};
export type jobsQuery$data = {
  readonly getQuartzJobs: {
    readonly " $fragmentSpreads": FragmentRefs<"jobsQueryFragment">;
  };
};
export type jobsQuery = {
  response: jobsQuery$data;
  variables: jobsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "includeJobData"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageNum"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDir"
},
v7 = [
  {
    "kind": "Variable",
    "name": "includeJobData",
    "variableName": "includeJobData"
  },
  {
    "kind": "Variable",
    "name": "pageNum",
    "variableName": "pageNum"
  },
  {
    "kind": "Variable",
    "name": "pageSize",
    "variableName": "pageSize"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "searchBy",
    "variableName": "searchBy"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  },
  {
    "kind": "Variable",
    "name": "sortDir",
    "variableName": "sortDir"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "group",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "jobsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "QuartzJobSummaryPage",
        "kind": "LinkedField",
        "name": "getQuartzJobs",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "jobsQueryFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "jobsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "QuartzJobSummaryPage",
        "kind": "LinkedField",
        "name": "getQuartzJobs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QuartzJobSummary",
            "kind": "LinkedField",
            "name": "content",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobClass",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestsRecovery",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobData",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuartzTriggerSummary",
                "kind": "LinkedField",
                "name": "triggers",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previousFireTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nextFireTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priority",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "misfireInstruction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cronExpression",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZoneId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aggregateState",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPrevious",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFirst",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLast",
                "storageKey": null
              },
              {
                "alias": "pageNum",
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": "pageSize",
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Sort",
                "kind": "LinkedField",
                "name": "sort",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSorted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnsorted",
                    "storageKey": null
                  },
                  {
                    "alias": "orders",
                    "args": null,
                    "concreteType": "Order",
                    "kind": "LinkedField",
                    "name": "toList",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "direction",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAscending",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDescending",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "property",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalElements",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aa6c5328f61fe219d06e77674bda138d",
    "id": null,
    "metadata": {},
    "name": "jobsQuery",
    "operationKind": "query",
    "text": "query jobsQuery(\n  $includeJobData: Boolean = true\n  $pageNum: Int\n  $pageSize: Int\n  $sortBy: String\n  $sortDir: SortDirection\n  $search: String\n  $searchBy: [String]\n) {\n  getQuartzJobs(includeJobData: $includeJobData, pageNum: $pageNum, pageSize: $pageSize, sortBy: $sortBy, sortDir: $sortDir, search: $search, searchBy: $searchBy) {\n    ...jobsQueryFragment\n  }\n}\n\nfragment jobsQueryFragment on QuartzJobSummaryPage {\n  content {\n    name\n    group\n    jobClass\n    description\n    durable\n    requestsRecovery\n    jobData\n    triggers {\n      name\n      group\n      type\n      state\n      previousFireTime\n      nextFireTime\n      priority\n      misfireInstruction\n      cronExpression\n      timeZoneId\n    }\n    aggregateState\n  }\n  pageInfo {\n    ...listPaginationQueryFragment\n  }\n}\n\nfragment listPaginationQueryFragment on PageInfo {\n  hasContent\n  hasNext\n  hasPrevious\n  isFirst\n  isLast\n  pageNum: number\n  pageSize: size\n  sort {\n    ...listPaginationQuerySortFragment\n  }\n  totalElements\n  totalPages\n}\n\nfragment listPaginationQuerySortFragment on Sort {\n  isSorted\n  isUnsorted\n  orders: toList {\n    direction\n    isAscending\n    isDescending\n    property\n  }\n}\n"
  }
};
})();

(node as any).hash = "d6446278ff9925bd6d3df5fc348009cd";

export default node;
